import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import KineticHero from "../components/KineticHero";
import MarketplaceSection from "../components/MarketplaceSection";
import ProjectDetailModal from "../components/ProjectDetailModal";

export default function Home({ onOpenSubmit }) {
  const [projects, setProjects] = useState([]);
  const [selected, setSelected] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, lang } = useLang();
  const { user } = useAuth();

  const openProject = (p) => {
    if (!user) { toast.info(t.mkt_login_details); navigate("/auth"); return; }
    setSelected(p);
  };

  useEffect(() => {
    const fetchProjects = () => api.get(`/projects?lang=${lang}`).then((r) => setProjects(r.data)).catch(() => {});
    fetchProjects();
    window.addEventListener("kmu:data-changed", fetchProjects);
    return () => window.removeEventListener("kmu:data-changed", fetchProjects);
  }, [lang]);

  useEffect(() => {
    if (new URLSearchParams(location.search).get("open_submit")) {
      onOpenSubmit();
      navigate("/", { replace: true });
    }
  }, [location.search, onOpenSubmit, navigate]);

  return (
    <main data-testid="home-page">
      <KineticHero onSubmit={onOpenSubmit} />
      <MarketplaceSection projects={projects} onOpen={openProject} />
      <ProjectDetailModal project={selected} onClose={() => setSelected(null)} />
    </main>
  );
}
